import React, { useState } from "react";

import ContactForm from "../ContactForm";

export const Contact = (props) => {
  const [isContactSubmitted, setIsContactSubmitted] = useState(false);
  return (
    <div className="">
      <div className="u-flexCenter">
        {isContactSubmitted ? (
          <h2 className="u-marginTop40 u-fontSize18 u-flexCenter u-justifyContentCenter u-height40 u-fontWeightBold u-textAlignCenter">
            Thank you !
          </h2>
        ) : (
          <ContactForm
            {...props}
            onSuccess={() => setIsContactSubmitted(true)}
          />
        )}
      </div>
    </div>
  );
};
